import { formatApiError, showError, showSuccess } from "@/lib/utils/notifications";

/**
 * Angular `resendInvite` parity (resident-application-add):
 * - Confirm dialog closes on Yes before the HTTP call
 * - Success → toast "Invite Sent Successfully"
 * - Failure → Validation Message modal with server body (`notify(error.error, 0)`)
 */
export async function confirmResendInvite(options: {
  inviteCode: string;
  resendInvitation: (code: string) => Promise<unknown>;
  closeConfirm: () => void;
}): Promise<void> {
  const { inviteCode, resendInvitation, closeConfirm } = options;

  closeConfirm();

  try {
    await resendInvitation(inviteCode);
    showSuccess("Invite Sent Successfully");
  } catch (error: unknown) {
    showError(formatApiError(error), false);
  }
}
